import usStates from "@lib/shared/us_states.json";
import type { Option } from "@sprout/select";

export const US_STATES: Option[] = usStates as Option[];
